/**
 * Function used to inform iOS of the successfull redirection
 *
 * (we should keep the console for now for debugging purpose)
 *
 * @param id id of the redirection that we send back to iOS
 */
export const onRedirectSuccessFromIOS = (id: string | null = null) => {
  const navigationStore = useNavigationStore()
  const route = useRoute()

  if (navigationStore.embed) {
    window.dispatchEvent(new CustomEvent('redirected', { detail: { id: id ? id : route.query.id } }))
  }
}
